// extracted by mini-css-extract-plugin
export var messageSideLeft = "_sh-1";
export var stateContainer = "_sh-0";